import { createNudgeboxAuthClient } from "@nudgebox/auth/client";

export const authClient = createNudgeboxAuthClient(window.location.origin);
